"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("../component"));

var _group = _interopRequireDefault(require("../group"));

var _radiobutton = _interopRequireDefault(require("./radiobutton.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var RadioButtonGroup = /*#__PURE__*/function (_Component) {
  _inherits(RadioButtonGroup, _Component);

  var _super = _createSuper(RadioButtonGroup);

  function RadioButtonGroup() {
    var _this;

    _classCallCheck(this, RadioButtonGroup);

    _this = _super.call(this);
    _this.state = {
      value: null
    };
    _this.onButtonSelected = _this.onButtonSelected.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(RadioButtonGroup, [{
    key: "onButtonSelected",
    value: function onButtonSelected(value) {
      this.setState({
        value: value
      });
      this.props.onChange && this.props.onChange(value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var value = this.props.value || this.state.value;

      var buttons = _react.default.Children.map(this.props.children, function (child, index) {
        var props = {
          selected: value === child.props.value,
          onSelected: _this2.onButtonSelected,
          inline: _this2.props.inline,
          disabled: _this2.props.disabled
        };

        if (_this2.props.inline && index < _this2.props.children.length - 1) {
          props.style = {
            marginRight: "var(--space-inline-m)"
          };
        }

        return /*#__PURE__*/_react.default.cloneElement(child, props);
      });

      return /*#__PURE__*/_react.default.createElement(_group.default, {
        disabled: this.props.disabled,
        label: this.props.label,
        inline: this.props.inline
      }, buttons);
    }
  }]);

  return RadioButtonGroup;
}(_component.default);
/*---------------------------------------------*/


RadioButtonGroup.METADATA = {
  name: "Radiobuttongroup",
  props: [{
    name: "label",
    type: "string",
    default: "Radio Button Group label",
    description: "Label"
  }, {
    name: "value",
    type: "string"
  }, {
    name: "disabled",
    type: "boolean",
    default: false
  }, {
    name: "inline",
    type: "boolean",
    default: false
  }, {
    name: "error",
    type: "boolean",
    default: false
  }, {
    name: "forcehover",
    type: "boolean",
    default: false
  }, {
    name: "forcefocus",
    type: "boolean",
    default: false
  }, {
    name: "onChange",
    type: "function",
    description: "Callback function called after the value is changed"
  }],
  content: {
    default: [/*#__PURE__*/_react.default.createElement(_radiobutton.default, {
      label: "Option 1",
      value: "value1",
      key: "value1"
    }), /*#__PURE__*/_react.default.createElement(_radiobutton.default, {
      label: "Option 2",
      value: "value2",
      key: "value2"
    }), /*#__PURE__*/_react.default.createElement(_radiobutton.default, {
      label: "Option 3",
      value: "value3",
      key: "value3"
    })]
  }
};
/*---------------------------------------------*/

/*---------------------------------------------*/

var _default = RadioButtonGroup;
exports.default = _default;